var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiaAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,13.5H4l0.1-0.4c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.2-0.1 c0,0,0.1-0.1,0.1-0.1l1.1-8.2h-2c-0.1,0-0.1,0-0.2,0.1C4.1,4.4,4.1,4.5,4,4.6C3.9,4.7,3.8,4.8,3.7,5C3.6,5.2,3.5,5.5,3.4,5.8L3,5.6 c0-0.1,0-0.3,0.1-0.5c0-0.2,0.1-0.4,0.1-0.6C3.3,4.4,3.3,4.2,3.4,4c0.1-0.2,0.1-0.3,0.1-0.5h7.3L11,3.7c0,0.1,0,0.3-0.1,0.5 c0,0.2-0.1,0.4-0.1,0.5c0,0.2-0.1,0.4-0.1,0.5c0,0.2-0.1,0.3-0.1,0.5h-0.4c0-0.3,0-0.5,0-0.7c0-0.2,0-0.3-0.1-0.4 c0-0.1-0.1-0.2-0.1-0.2C9.8,4.3,9.7,4.3,9.6,4.3H7.7l-1.1,8.2c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2 c0.1,0.1,0.3,0.1,0.5,0.2L7.6,13.5z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,8.8c-0.4,0-0.5,0.1-0.6,0.4c-0.1,0.2-0.1,0.4-0.2,1l-0.5,2.4H13l-1.8-3.1L10.9,11c-0.1,0.5-0.1,0.8-0.2,1 c0,0.3,0.1,0.3,0.5,0.4l0,0.2H9.8l0-0.2c0.4,0,0.5-0.1,0.6-0.4c0.1-0.2,0.1-0.5,0.2-1L11,9.4c0-0.2,0-0.4-0.1-0.4 c-0.1-0.1-0.2-0.1-0.5-0.2l0-0.2h1l1.7,2.9l0.2-1.3c0.1-0.6,0.1-0.8,0.2-1c0-0.3-0.1-0.4-0.5-0.4l0-0.2h1.5L14.5,8.8z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiaAdd);
export default __webpack_public_path__ + "static/media/TiaAdd.ae05d04ee8979ed2c61f3672e3ed8ea2.svg";
export { ForwardRef as ReactComponent };